import React from 'react'
import ReactDOM from 'react-dom'
import {DraggableContainer, DraggableItem} from 'startlibs/lib/components'
import {RichTextEditor} from '../../components/richText'
import {EditableLabel} from '../../components/editableLabel'
import {Fill} from 'react-slot-fill'
import {ice} from 'icepath'

export class Fields extends React.Component<{}, {}, { deletedField: any, openId: number }> {
  state = {}

  addNew = () => {
    this.setState({openId: this.props.newId})
    this.props.addNew({label: 'Field Label', type: 'richtext', value: '', id: this.props.newId})
  }

  undoDelete = () => {
    const {field, index} = this.state.deletedField
    this.props.addNew(field, index)
    this.setState({deletedField: null, openId: null})
  }

  deleteField = (field) => {
    const index = this.props.fields.findIndex(_ => _.id === field.id)
    this.setState({deletedField: {index, field}})
    setTimeout(
      () => {
        if (this.state.deletedField) {
          this.setState({deletedField: null})
          this.props.confirmRemoveItem(field.id)
        }
      }
      , 10000)
    this.props.removeItem(field.id)
  }

  setItemOrder = (from, to) => {
    const oldOrder = this.props.fields.map(_ => _.id)
    const newOrder = ice(oldOrder).splice(from, 1).splice(to, 0, oldOrder[from]).value()
    this.props.updateOrder(newOrder)
  }

  render() {
    const {fields, labels, autoSaveUpdate, updateItem, errorsIds} = this.props
    const {openId, deletedField} = this.state
    return (
      <div className="report-fields-list">
        <DraggableContainer
          className="drag-drop-limits"
          noResistance
          setDragRef={this.props.setDragRef}
          setItemOrder={this.setItemOrder}
        >
          {fields.map((field, i) =>
            <Field
              key={field.id}
              field={field}
              index={i}
              hasErrors={(errorsIds||[]).indexOf(field.id)>=0}
              labels={labels}
              autoSaveUpdate={autoSaveUpdate}
              updateItem={updateItem}
              deleteField={this.deleteField}
              isLabelEditOpen={field.id === openId}
            />
          )}
        </DraggableContainer>
        <a className="button outline add-field-button" onClick={this.addNew}>
          <span className="icon icon-plus-circle"/>Add field
        </a>
        {
          deletedField &&
          <Fill name="Notifications">
            <div className="system-notification undo-notification">
              Field successfully deleted
              <a className="button small-button" onClick={this.undoDelete}>Undo</a>
            </div>
          </Fill>
        }
      </div>
    )
  }
}

class Field extends React.Component {

  modified = false

  handleChange = (value) => {
    this.modified = this.modified || this.props.field.value !== value
    this.props.updateItem({...this.props.field, value, modified: true})
  }

  handleLabelChange = (label) => {
    const field = {...this.props.field, label}
    this.props.updateItem(field)
    this.modified = false
    this.props.autoSaveUpdate(field)
  }

  autoSave = (e) => {
    if (e.target.innerHTML !== this.props.field.value || this.modified) {
      this.modified = false
      this.handleChange(e.target.innerHTML)
      this.props.autoSaveUpdate({...this.props.field, value:e.target.innerHTML, modified: true})
    }
  }

  deleteField = (e) => {
    this.props.deleteField(this.props.field)
  }

  componentDidMount() {
    const event = new CustomEvent('scrollToNewField',{detail:ReactDOM.findDOMNode(this)});
    window.dispatchEvent(event);
  }

  render() {
    const {field, index, labels, isLabelEditOpen, hasErrors} = this.props

    const labelList = () => labels.map((label, i) =>
      <li
        key={i}
        className={label === field.label ? 'selected' : ''}
        onClick={() => this.handleLabelChange(label)}
      >
        <a>{label}</a>
      </li>
    )

    return (
      <DraggableItem
        index={index}
        ghostScale={1.015}
        className={"report-field-item draggable-field-item"+ (hasErrors? ' has-errors':'')}
      >
        <EditableLabel
          isLabelEditOpen={isLabelEditOpen}
          isContextMenuOpen={isLabelEditOpen}
          value={field.label}
          labelList={labelList}
          handleChange={this.handleLabelChange}
        />
        <RichTextEditor onBlur={this.autoSave} defaultValue={field.value} onChange={this.handleChange}/>
        <a data-drag={false} onClick={this.deleteField} className="icon icon-x"/>
      </DraggableItem>
    )
  }
}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/editor/Fields.js